function pushToDataLayer(event) {
    if (!window.dataLayer) {
        window.dataLayer = [];
    } else {
        window.dataLayer = window.dataLayer || [];
    }

    window.dataLayer.push({ event });
}

function pushToDataLayerWithValue(event, key, value) {
    if (!window.dataLayer) {
        window.dataLayer = [];
    } else {
        window.dataLayer = window.dataLayer || [];
    }

    window.dataLayer.push({ event, [key]: value });
}

export { pushToDataLayer, pushToDataLayerWithValue };
